import React from 'react';

export default function SceneDisplay({ sceneElements, instructions }) {
    const style = {
        fontFamily: "'Courier New', Courier, monospace",
        whiteSpace: 'pre-wrap'
    };
    
    return (
        <div className="card">
            <div className="card-body">
                 {instructions && (
                     <div className="alert alert-info">
                        <h5 className="alert-heading">Instructions:</h5>
                        <p>{instructions}</p>
                    </div>
                )}
                <div className="p-3 bg-light" style={{ minHeight: '300px' }}>
                    {sceneElements.map((element, index) => (
                        <p key={index} style={style} className={element.actor === 'user' ? 'text-primary' : 'text-dark'}>
                            {element.content}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
}
